import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';
import type {
	PartialVariantRoute,
	Route,
} from '@atlassian/react-resource-router/src/common/types.tsx';
import { createRouteEntry } from './createRouteEntry.tsx';

/**
 * Create a route entry for single-page application pages.
 * @agent-skills: routing, creating-a-page
 */
export const createEntry: (
	baseRoute: InvariantJiraRoute,
	opts: () => PartialVariantRoute,
) => Route = createRouteEntry<InvariantJiraRoute, PartialVariantRoute, Route>;
